import { gql } from '@apollo/client';

export const UPDATE_PAYMENT_REMINDER = gql`
  mutation updatePaymentReminder($id: Int, $paymentreminder: Boolean) {
    updatePaymentReminder(id: $id, paymentreminder: $paymentreminder) {
      paymentreminder
    }
  }
`;
